import { Dropdown, Form, Icon, InputNumber, Menu, Spin } from 'antd';
import React, { useCallback } from 'react';
import useTariffsTypes from '../../queries/useTariffsTypes';
import DeleteButton from '../DeleteButton/DeleteButton';
import styles from './AddTariffFields.module.scss';

const AddTariffFields = ({ tariffs = [], setTariffs }) => {
  const { data: meterTariffTypes, isFetching: meterTariffTypesFetching } =
    useTariffsTypes();

  const menu = useCallback(
    (index) => (
      <Menu
        onClick={(clickParam) => {
          const tariffType = meterTariffTypes.find(
            (tariff) => +tariff.id === +clickParam.key
          );
          const newTariffs = [...tariffs];
          newTariffs[index].tariff = tariffType;

          if (newTariffs[index].notIndicated) {
            newTariffs[index].notIndicated = false;
          }

          setTariffs(newTariffs);
        }}
      >
        {meterTariffTypes.map((tariff) => (
          <Menu.Item key={tariff.id}>{tariff.name}</Menu.Item>
        ))}
      </Menu>
    ),
    [setTariffs, tariffs, meterTariffTypes]
  );

  const handleInputNumberChange = (value, index) => {
    const newTariffs = [...tariffs];
    const item = newTariffs[index];
    let error = '';

    if (value <= 0) {
      error = 'Значение должно быть больше 0';
    } else if (value === '') {
      error = 'Укажите значение';
    } else {
      error = '';

      if (!item.tariff) {
        item.notIndicated = true;
      }
    }

    item.value = value;
    item.error = error;

    setTariffs(newTariffs);
  };

  return (
    <Spin spinning={meterTariffTypesFetching}>
      <div className={styles.tariffsList}>
        {tariffs.map((tariff, index) => (
          <div className={styles.tariff} key={`${tariff.tariff?.id} ${index}`}>
            <div className={styles.tariffTypeContainer}>
              <Dropdown overlay={menu(index)}>
                <div className={styles.blockHighlight}>
                  {meterTariffTypes.find(
                    (tariffType) => +tariffType?.id === +tariff?.tariff?.id
                  )?.name || 'Выберите тип'}{' '}
                  <Icon type="down" />
                </div>
              </Dropdown>
              {tariff.notIndicated && (
                <p className={styles.tariffError}>Укажите тип тарифа</p>
              )}
            </div>
            <div className={styles.value}>
              <span className={styles.text}>Тариф</span>
              <Form.Item
                className={styles.inputWrapper}
                validateStatus={tariff.error ? 'error' : 'success'}
                help={tariff.error}
              >
                <InputNumber
                  max={99999.99}
                  value={tariff.value}
                  className={styles.inputTariffValue}
                  decimalSeparator=","
                  onChange={(value) => handleInputNumberChange(value, index)}
                />
              </Form.Item>

              {(!tariff.id || tariff.canDelete) && (
                <DeleteButton
                  onClick={() => {
                    const newTariffs = [...tariffs];
                    newTariffs.splice(index, 1);
                    setTariffs(newTariffs);
                  }}
                />
              )}
            </div>
          </div>
        ))}
        <div
          className={styles.addTariffButton}
          onClick={() => {
            setTariffs([
              ...tariffs,
              { tariff: null, value: '', error: '', notIndicated: false },
            ]);
          }}
        >
          <Icon type="plus-circle" /> Добавить тариф
        </div>
      </div>
    </Spin>
  );
};

export default AddTariffFields;
